import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Card } from '../../../interfaces/payment';

@Component({
  selector: 'ng-tickets-confirm-cvv',
  styleUrls: ['./confirm-cvv.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <section>
      <h2 class="title-section">Confirmar código de segurança</h2>

      <ng-tickets-card-item
          [removable]="false"
          [selectable]="false"
          [card]="card">
      </ng-tickets-card-item>

      <form #form="ngForm">
        <div class="row container-form-card">
          <div class="col-md-12 col-sm-12">
            <div class="form-group">
              <label style="margin-right: 10px">CVV:</label>
              <input class="form-control" type="text" name="cvv" [(ngModel)]="card.cvv" required>
              <span class="error-description"></span>
            </div>
          </div>
        </div>
      </form>

      <div class="container-button">
        <button class="btn btn-pink" (click)="nextStep.emit('card-list')"><i class="fa fa-chevron-left"></i> Voltar</button>
        <button class="btn btn-pink" (click)="nextStep.emit('card-selection')" [disabled]="form.invalid">
          Adicionar <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </section>
  `
})
export class ConfirmCVVComponent implements OnInit {

  @Input() card: Card;
  @Output() nextStep = new EventEmitter();

  ngOnInit() {
    if (this.card  && this.card.cvv) {
      this.nextStep.emit('send-data');
    }
  }

}
